import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/* Alte URL /digital → dauerhaft nach /social.
   Prerendert mit canonical=/social + robots noindex,follow, damit Suchmaschinen die Alt-URL
   aus dem Index nehmen und die Signale auf /social bündeln. Nutzer werden clientseitig weitergeleitet. */
const ZIEL = "/social";

export default function DigitalWeiterleitung() {
  useEffect(() => { window.location.replace(ZIEL); }, []);
  return (
    <>
      <Helmet>
        <title>Seite umgezogen – weiter zu Social Media | DIMEDIAL</title>
        <meta name="robots" content="noindex,follow" />
        <meta name="description" content="Diese Seite ist umgezogen. Weiter zu DIMEDIAL Social Media." />
        <link rel="canonical" href="https://dimedial.studio/social" />
      </Helmet>
      <main className="min-h-[60vh] grid place-items-center px-6 text-center" data-testid="digital-weiterleitung">
        <div className="max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#4A4A4A]">Diese Seite ist umgezogen</p>
          <h1 className="mt-3 text-2xl font-extrabold text-[#111]">Weiter zu Social Media</h1>
          <p className="mt-3 text-[#4A4A4A]">Du wirst automatisch weitergeleitet.</p>
          <p className="mt-5"><a href={ZIEL} className="inline-flex rounded-full bg-[#111] text-white px-5 py-2.5 text-sm font-bold" data-testid="digital-weiterleitung-link">Jetzt zu Social Media</a></p>
        </div>
      </main>
    </>
  );
}
